<!-- ======================================================================== -->
<!-- FLOATING TAB BAR — Bouton flottant bas-droite avec 3 onglets            -->
<!-- ======================================================================== -->
<div
  #floatingBar
  class="notes-todos-floating-bar"
  [class.notes-todos-floating-bar--open]="isOpen"
  [class.notes-todos-floating-bar--collapsed]="isCollapsed"
>
  @if (!isCollapsed) {
    <eva-button
      class="notes-todos-floating-bar__tab"
      [class.notes-todos-floating-bar__tab--active]="selectedView === 'tasks'"
      icon="pi pi-list"
      label="Tâches"
      [variant]="selectedView === 'tasks' ? 'soft' : 'text'"
      [severity]="selectedView === 'tasks' ? 'primary' : 'secondary'"
      size="small"
      [badge]="tasksBadge"
      [badgeSeverity]="tasksOverdue ? 'danger' : 'secondary'"
      (onClick)="openWithView('tasks')"
    />

    <eva-button
      class="notes-todos-floating-bar__tab"
      [class.notes-todos-floating-bar__tab--active]="selectedView === 'notes'"
      icon="pi pi-file-edit"
      label="Notes"
      [variant]="selectedView === 'notes' ? 'soft' : 'text'"
      [severity]="selectedView === 'notes' ? 'primary' : 'secondary'"
      size="small"
      (onClick)="openWithView('notes')"
    />

    @if (showAssistantTab) {
      <eva-button
        class="notes-todos-floating-bar__tab notes-todos-floating-bar__tab--assistant"
        [class.notes-todos-floating-bar__tab--active]="selectedView === 'assistant'"
        [icon]="aiSession.anyBusy() ? 'pi pi-spin pi-spinner' : 'pi pi-sparkles'"
        [label]="aiSession.anyBusy() ? 'Réflexion…' : 'Assistant'"
        [variant]="selectedView === 'assistant' ? 'filled' : 'text'"
        severity="primary"
        size="small"
        [badge]="aiSession.unread() ? 1 : null"
        badgeSeverity="danger"
        (onClick)="openWithView('assistant')"
      />
    }

    @if (hasConversations) {
      <eva-button
        class="notes-todos-floating-bar__tab"
        [class.notes-todos-floating-bar__tab--active]="selectedView === 'conversations'"
        icon="pi pi-comments"
        label="Conversations"
        [variant]="selectedView === 'conversations' ? 'soft' : 'text'"
        [severity]="selectedView === 'conversations' ? 'primary' : 'secondary'"
        size="small"
        [badge]="conversationsCount > 0 ? (conversationsCount > 99 ? '99+' : conversationsCount) : null"
        badgeSeverity="danger"
        (onClick)="openWithView('conversations')"
      />
    }
  }

  <!-- Bouton replier/déplier -->
  <button
    type="button"
    class="notes-todos-floating-bar__toggle"
    (click)="toggleCollapse()"
    [attr.aria-label]="isCollapsed ? 'Déplier la barre' : 'Replier la barre'"
  >
    <i class="pi" [class.pi-chevron-right]="!isCollapsed" [class.pi-chevron-left]="isCollapsed"></i>
    @if (isCollapsed && totalNotifications > 0) {
      <span class="notes-todos-floating-bar__total-badge">
        {{ totalNotifications > 99 ? "99+" : totalNotifications }}
      </span>
    }
  </button>
</div>

<!-- ======================================================================== -->
<!-- BACKDROP                                                                 -->
<!-- ======================================================================== -->
@if (isOpen) {
  <div class="notes-todos-backdrop" (click)="onBackdropClick()"></div>
}

<!-- ======================================================================== -->
<!-- FLOATING WINDOW — Fenêtre flottante au-dessus du bouton                 -->
<!-- ======================================================================== -->
@if (isOpen && activeView) {
  <div
    class="notes-todos-window"
    (click)="onDrawerContentClick($event)"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="getWindowTitle()"
  >
    <!-- ================================================================== -->
    <!-- BODY (scrollable)                                                   -->
    <!-- ================================================================== -->
    <div class="notes-todos-window__body">
      <!-- ============================================================== -->
      <!-- VUE TÂCHES                                                      -->
      <!-- ============================================================== -->
      @if (activeView === "tasks") {
        <div class="notes-todos-window__view notes-todos-window__view--tasks">
          <app-drawer-tasks [objectContext]="currentObjectContext"></app-drawer-tasks>
        </div>
      }

      <!-- ============================================================== -->
      <!-- VUE NOTES                                                       -->
      <!-- ============================================================== -->
      @if (activeView === "notes") {
        <div class="notes-todos-window__view notes-todos-window__view--notes">
          <!-- Mode liste -->
          @if (noteViewMode === "list") {
            <app-notes-list
              #notesList
              [context]="context"
              [pageContext]="routeContext"
              (noteSelected)="openNote($event)"
              (createNote)="createNote()"
              (contextFilterRemoved)="onContextFilterRemoved()"
              (contextFilterRestored)="onContextFilterRestored()"
            ></app-notes-list>
          }

          <!-- Mode détail -->
          @if (noteViewMode === "detail") {
            <app-notes-detail
              [noteId]="currentNoteId"
              [context]="context"
              (backToList)="backToList()"
            ></app-notes-detail>
          }
        </div>
      }

      <!-- ============================================================== -->
      <!-- VUE ASSISTANT                                                   -->
      <!-- ============================================================== -->
      @if (activeView === "assistant") {
        <div class="notes-todos-window__view notes-todos-window__view--assistant">
          <app-ai-home-chat variant="drawer" (closed)="close()"></app-ai-home-chat>
        </div>
      }

      <!-- ============================================================== -->
      <!-- VUE CONVERSATIONS                                               -->
      <!-- ============================================================== -->
      @if (activeView === "conversations") {
        <div class="notes-todos-window__view notes-todos-window__view--conversations">
          <app-drawer-conversations #conversationsRef></app-drawer-conversations>
        </div>
      }
    </div>
  </div>
}
